module.exports = __webpack_public_path__ + "static/media/list-music.a2e4c98b.svg";